// Ссылки на элементы каркаса. Ищутся один раз, сразу после монтирования разметки.

import { ensureAppShell } from './shell';

ensureAppShell();

export function element<T extends HTMLElement>(selector: string): T {
  const found = document.querySelector<T>(selector);
  if (!found) throw new Error(`Элемент ${selector} не найден`);
  return found;
}

export const controls = {
  applicationShell: element<HTMLElement>('.application-shell'),
  workspace: element<HTMLElement>('.workspace'),
  palettePanel: element<HTMLElement>('.palette-panel'),
  builderPanel: element<HTMLElement>('.builder-panel'),
  canvasPanel: element<HTMLElement>('.canvas-panel'),
  canvasHeader: element<HTMLElement>('.canvas-header'),
  canvasScroll: element<HTMLElement>('.canvas-scroll'),
  canvasScaleShell: element<HTMLElement>('#dashboard-scale-shell'),
  canvasScaleInner: element<HTMLElement>('#dashboard-scale-inner'),
  dashboardSelect: element<HTMLSelectElement>('#dashboard-select'),
  dashboardName: element<HTMLInputElement>('#dashboard-title-input'),
  dashboardTitleButton: element<HTMLButtonElement>('#dashboard-title-button'),
  dashboardTitleText: element<HTMLElement>('#dashboard-title-text'),
  dashboardManagerButton: element<HTMLButtonElement>('#dashboard-manager-button'),
  dashboardManagerDialog: element<HTMLDialogElement>('#dashboard-manager-dialog'),
  dashboardManagerClose: element<HTMLButtonElement>('#dashboard-manager-close'),
  dashboardManagerSearch: element<HTMLInputElement>('#dashboard-manager-search'),
  dashboardManagerList: element<HTMLElement>('#dashboard-manager-list'),
  dashboardManagerTabs: element<HTMLElement>('.dashboard-manager-tabs'),
  dashboardManagerDemoHint: element<HTMLElement>('#dashboard-manager-demo-hint'),
  dashboardManagerNew: element<HTMLButtonElement>('#dashboard-manager-new'),
  dashboardVisibility: element<HTMLButtonElement>('#dashboard-visibility'),
  authArea: element<HTMLElement>('#auth-area'),
  authSignIn: element<HTMLButtonElement>('#auth-sign-in'),
  authUserButton: element<HTMLButtonElement>('#auth-user-button'),
  authUserName: element<HTMLElement>('#auth-user-name'),
  authUserMenu: element<HTMLElement>('#auth-user-menu'),
  authUserMenuName: element<HTMLElement>('#auth-user-menu-name'),
  authUserMenuEmail: element<HTMLElement>('#auth-user-menu-email'),
  authUserMenuRole: element<HTMLElement>('#auth-user-menu-role'),
  authSignOut: element<HTMLButtonElement>('#auth-sign-out'),
  authBanner: element<HTMLElement>('#auth-banner'),
  authBannerText: element<HTMLElement>('#auth-banner-text'),
  authBannerSignIn: element<HTMLButtonElement>('#auth-banner-sign-in'),
  emptyAddWidget: element<HTMLButtonElement>('#empty-add-widget'),
  emptyAutoBuilder: element<HTMLButtonElement>('#empty-auto-builder'),
  emptyDashboardManager: element<HTMLButtonElement>('#empty-dashboard-manager'),
  canvasTitle: element<HTMLElement>('#canvas-title'),
  globalStatus: element<HTMLElement>('#global-status'),
  dirtyIndicator: element<HTMLElement>('#dirty-indicator'),
  widgetCounter: element<HTMLElement>('#widget-counter'),
  emptyState: element<HTMLElement>('#empty-state'),
  source: element<HTMLSelectElement>('#source-select'),
  indicatorField: element<HTMLElement>('#indicator-field'),
  indicator: element<HTMLSelectElement>('#indicator-select'),
  indicatorDescription: element<HTMLElement>('#indicator-description'),
  indicatorSectionField: element<HTMLElement>('#indicator-section-field'),
  indicatorSection: element<HTMLSelectElement>('#indicator-section-select'),
  indicatorSearch: element<HTMLInputElement>('#indicator-search'),
  builderHelp: element<HTMLButtonElement>('#builder-help'),
  leftEmissCatalogPicker: element<HTMLElement>('#left-emiss-catalog-picker'),
  leftEmissCatalogStatus: element<HTMLElement>('#left-emiss-catalog-status'),
  leftEmissCatalogQuery: element<HTMLInputElement>('#left-emiss-catalog-query'),
  leftEmissCatalogSearch: element<HTMLButtonElement>('#left-emiss-catalog-search'),
  leftEmissCatalogRefresh: element<HTMLButtonElement>('#left-emiss-catalog-refresh'),
  leftEmissCatalogIncludeExcluded: element<HTMLInputElement>('#left-emiss-catalog-include-excluded'),
  leftEmissCatalogResults: element<HTMLElement>('#left-emiss-catalog-results'),
  leftEmissSelected: element<HTMLElement>('#left-emiss-selected'),
  leftEmissOpenManager: element<HTMLButtonElement>('#left-emiss-open-manager'),
  leftWorldBankCatalogPicker: element<HTMLElement>('#left-worldbank-catalog-picker'),
  leftWorldBankCatalogStatus: element<HTMLElement>('#left-worldbank-catalog-status'),
  leftWorldBankCatalogQuery: element<HTMLInputElement>('#left-worldbank-catalog-query'),
  leftWorldBankCatalogSearch: element<HTMLButtonElement>('#left-worldbank-catalog-search'),
  leftWorldBankCatalogRefresh: element<HTMLButtonElement>('#left-worldbank-catalog-refresh'),
  leftWorldBankCatalogResults: element<HTMLElement>('#left-worldbank-catalog-results'),
  leftWorldBankSelected: element<HTMLElement>('#left-worldbank-selected'),
  territoryLevel: element<HTMLSelectElement>('#territory-level'),
  districtFilter: element<HTMLSelectElement>('#district-filter'),
  districtFilterField: element<HTMLElement>('#district-filter-field'),
  regionFilter: element<HTMLSelectElement>('#region-filter'),
  regionFilterField: element<HTMLElement>('#region-filter-field'),
  territorySearch: element<HTMLInputElement>('#territory-search'),
  territorySearchField: element<HTMLElement>('#territory-search-field'),
  territories: element<HTMLSelectElement>('#territory-select'),
  territoryChoiceList: element<HTMLElement>('#territory-choice-list'),
  territoryCount: element<HTMLElement>('#territory-count'),
  years: element<HTMLSelectElement>('#year-select'),
  yearChoiceList: element<HTMLElement>('#year-choice-list'),
  yearSelectionHint: element<HTMLElement>('#year-selection-hint'),
  selectAllYears: element<HTMLButtonElement>('#select-all-years'),
  clearYears: element<HTMLButtonElement>('#clear-years'),
  months: element<HTMLSelectElement>('#month-select'),
  monthField: element<HTMLElement>('#month-field'),
  periodSemantics: element<HTMLElement>('#period-semantics'),
  dimensionFields: element<HTMLElement>('#dimension-fields'),
  visualization: element<HTMLSelectElement>('#visualization-select'),
  visualizationPalette: element<HTMLElement>('#visualization-palette'),
  title: element<HTMLInputElement>('#widget-title-input'),
  titleEn: element<HTMLInputElement>('#widget-title-en-input'),
  palette: element<HTMLSelectElement>('#palette-select'),
  orientation: element<HTMLSelectElement>('#orientation-select'),
  sortOrder: element<HTMLSelectElement>('#sort-order-select'),
  topN: element<HTMLInputElement>('#top-n-input'),
  axisScale: element<HTMLSelectElement>('#axis-scale-select'),
  includeZero: element<HTMLSelectElement>('#include-zero-select'),
  xAxisMin: element<HTMLInputElement>('#x-axis-min-input'),
  xAxisMax: element<HTMLInputElement>('#x-axis-max-input'),
  dataZoom: element<HTMLSelectElement>('#data-zoom-select'),
  showPoints: element<HTMLSelectElement>('#show-points-select'),
  legendPosition: element<HTMLSelectElement>('#legend-position-select'),
  smooth: element<HTMLInputElement>('#smooth-checkbox'),
  patterns: element<HTMLInputElement>('#patterns-checkbox'),
  decimals: element<HTMLInputElement>('#decimals-input'),
  legend: element<HTMLInputElement>('#legend-checkbox'),
  labels: element<HTMLInputElement>('#labels-checkbox'),
  reverse: element<HTMLInputElement>('#reverse-checkbox'),
  classification: element<HTMLSelectElement>('#classification-select'),
  classCount: element<HTMLInputElement>('#class-count-input'),
  manualBreaks: element<HTMLInputElement>('#manual-breaks-input'),
  manualBreaksField: element<HTMLElement>('#manual-breaks-field'),
  nullColor: element<HTMLInputElement>('#null-color-input'),
  mapScaleMode: element<HTMLSelectElement>('#map-scale-mode-select'),
  mapLegendMode: element<HTMLSelectElement>('#map-legend-mode-select'),
  mapBasemap: element<HTMLSelectElement>('#map-basemap-select'),
  mapFixedMin: element<HTMLInputElement>('#map-fixed-min-input'),
  mapFixedMax: element<HTMLInputElement>('#map-fixed-max-input'),
  mapFixedFields: Array.from(document.querySelectorAll<HTMLElement>('.map-fixed-field')),
  numberFormat: element<HTMLSelectElement>('#number-format-select'),
  labelMode: element<HTMLSelectElement>('#label-mode-select'),
  showUnit: element<HTMLInputElement>('#show-unit-checkbox'),
  tooltip: element<HTMLInputElement>('#tooltip-checkbox'),
  grid: element<HTMLInputElement>('#grid-checkbox'),
  animation: element<HTMLSelectElement>('#animation-select'),
  lineWidth: element<HTMLInputElement>('#line-width-input'),
  lineStyle: element<HTMLSelectElement>('#line-style-select'),
  lineCurve: element<HTMLSelectElement>('#line-curve-select'),
  connectNulls: element<HTMLInputElement>('#connect-nulls-checkbox'),
  areaOpacity: element<HTMLInputElement>('#area-opacity-input'),
  areaFillMode: element<HTMLSelectElement>('#area-fill-mode-select'),
  axisMin: element<HTMLInputElement>('#axis-min-input'),
  axisMax: element<HTMLInputElement>('#axis-max-input'),
  barLayout: element<HTMLSelectElement>('#bar-layout-select'),
  barWidth: element<HTMLInputElement>('#bar-width-input'),
  barGap: element<HTMLInputElement>('#bar-gap-input'),
  barLabelPosition: element<HTMLSelectElement>('#bar-label-position-select'),
  totalLabels: element<HTMLInputElement>('#total-labels-checkbox'),
  otherThreshold: element<HTMLInputElement>('#other-threshold-input'),
  pieVariant: element<HTMLSelectElement>('#pie-variant-select'),
  pieInnerRadius: element<HTMLInputElement>('#pie-inner-radius-input'),
  pieOuterRadius: element<HTMLInputElement>('#pie-outer-radius-input'),
  pieLabelMode: element<HTMLSelectElement>('#pie-label-mode-select'),
  pieStartAngle: element<HTMLInputElement>('#pie-start-angle-input'),
  pieRoseMode: element<HTMLSelectElement>('#pie-rose-mode-select'),
  heatmapTranspose: element<HTMLInputElement>('#heatmap-transpose-checkbox'),
  heatmapScaleMode: element<HTMLSelectElement>('#heatmap-scale-mode-select'),
  heatmapFixedMin: element<HTMLInputElement>('#heatmap-fixed-min-input'),
  heatmapFixedMax: element<HTMLInputElement>('#heatmap-fixed-max-input'),
  heatmapMissingColor: element<HTMLInputElement>('#heatmap-missing-color-input'),
  heatmapCellGap: element<HTMLInputElement>('#heatmap-cell-gap-input'),
  heatmapCellBorder: element<HTMLInputElement>('#heatmap-cell-border-checkbox'),
  pyramidSexDimension: element<HTMLInputElement>('#pyramid-sex-dimension-input'),
  pyramidAgeDimension: element<HTMLInputElement>('#pyramid-age-dimension-input'),
  pyramidMaleValue: element<HTMLInputElement>('#pyramid-male-value-input'),
  pyramidFemaleValue: element<HTMLInputElement>('#pyramid-female-value-input'),
  pyramidMode: element<HTMLSelectElement>('#pyramid-mode-select'),
  pyramidMaleColor: element<HTMLInputElement>('#pyramid-male-color-input'),
  pyramidFemaleColor: element<HTMLInputElement>('#pyramid-female-color-input'),
  kpiAggregation: element<HTMLSelectElement>('#kpi-aggregation-select'),
  kpiComparison: element<HTMLSelectElement>('#kpi-comparison-select'),
  kpiTarget: element<HTMLInputElement>('#kpi-target-input'),
  kpiSparkline: element<HTMLInputElement>('#kpi-sparkline-checkbox'),
  kpiSparklineStyle: element<HTMLSelectElement>('#kpi-sparkline-style-select'),
  kpiIconMode: element<HTMLSelectElement>('#kpi-icon-mode-select'),
  kpiIcon: element<HTMLInputElement>('#kpi-icon-input'),
  kpiIconPicker: element<HTMLElement>('#kpi-icon-picker'),
  kpiIconPickerField: element<HTMLElement>('#kpi-icon-picker-field'),
  kpiIconCustomField: element<HTMLElement>('#kpi-icon-custom-field'),
  tableColumns: element<HTMLSelectElement>('#table-columns-select'),
  tableDensity: element<HTMLSelectElement>('#table-density-select'),
  tablePageSize: element<HTMLInputElement>('#table-page-size-input'),
  tableCellVisual: element<HTMLSelectElement>('#table-cell-visual-select'),
  tableQuality: element<HTMLInputElement>('#table-quality-checkbox'),
  mapFillOpacity: element<HTMLInputElement>('#map-fill-opacity-input'),
  mapOutlineColor: element<HTMLInputElement>('#map-outline-color-input'),
  mapOutlineWidth: element<HTMLInputElement>('#map-outline-width-input'),
  mapBasemapOpacity: element<HTMLInputElement>('#map-basemap-opacity-input'),
  mapSymbolMinRadius: element<HTMLInputElement>('#map-symbol-min-radius-input'),
  mapSymbolMaxRadius: element<HTMLInputElement>('#map-symbol-max-radius-input'),
  mapSymbolScale: element<HTMLSelectElement>('#map-symbol-scale-select'),
  mapSymbolStrokeColor: element<HTMLInputElement>('#map-symbol-stroke-color-input'),
  mapSymbolStrokeWidth: element<HTMLInputElement>('#map-symbol-stroke-width-input'),
  mapSymbolOpacity: element<HTMLInputElement>('#map-symbol-opacity-input'),
  timeControl: element<HTMLInputElement>('#time-control-checkbox'),
  conditionOperator: element<HTMLSelectElement>('#condition-operator'),
  conditionValue: element<HTMLInputElement>('#condition-value'),
  conditionColor: element<HTMLInputElement>('#condition-color'),
  form: element<HTMLFormElement>('#widget-form'),
  formError: element<HTMLElement>('#form-error'),
  builderTitle: element<HTMLElement>('#builder-title'),
  submitWidget: element<HTMLButtonElement>('#submit-widget'),
  addAsNewWidget: element<HTMLButtonElement>('#add-as-new-widget'),
  inspectorEmpty: element<HTMLElement>('#inspector-empty'),
  appearanceInspector: element<HTMLElement>('#appearance-inspector'),
  mapSettings: element<HTMLDetailsElement>('#map-settings'),
  typeSpecificSettings: element<HTMLDetailsElement>('#type-specific-settings'),
  advancedSettings: element<HTMLDetailsElement>('#advanced-visual-settings'),
  gridRoot: element<HTMLElement>('#dashboard-grid'),
  togglePalette: element<HTMLButtonElement>('#toggle-palette'),
  showPalette: element<HTMLButtonElement>('#show-palette'),
  toggleBuilder: element<HTMLButtonElement>('#toggle-builder'),
  closeBuilder: element<HTMLButtonElement>('#close-builder'),
  builderBackdrop: element<HTMLButtonElement>('#builder-backdrop'),
  viewModeButton: element<HTMLButtonElement>('#view-mode-button'),
  toggleViewMode: element<HTMLButtonElement>('#toggle-view-mode'),
  toggleFilterbar: element<HTMLButtonElement>('#toggle-filterbar'),
  toggleLayout: element<HTMLButtonElement>('#toggle-layout'),
  compactLayout: element<HTMLButtonElement>('#compact-layout'),
  layoutHelp: element<HTMLElement>('#layout-help'),
  layoutStatus: element<HTMLElement>('#layout-status'),
  dashboardFilterbar: element<HTMLElement>('#dashboard-filterbar'),
  scopeFilter: element<HTMLSelectElement>('#scope-filter'),
  scopeFilterLabel: element<HTMLElement>('#scope-filter-label'),
  scopeFilterNote: element<HTMLElement>('#scope-filter-note'),
  emissDialog: element<HTMLDialogElement>('#emiss-dialog'),
  sourcesMenuButton: element<HTMLButtonElement>('#sources-menu-button'),
  sourcesMenu: element<HTMLElement>('#sources-menu'),
  sourcesEmissCatalog: element<HTMLButtonElement>('#sources-emiss-catalog'),
  sourcesEmissLog: element<HTMLButtonElement>('#sources-emiss-log'),
  openEmissManager: element<HTMLButtonElement>('#open-emiss-manager'),
  closeEmissManager: element<HTMLButtonElement>('#close-emiss-manager'),
  emissConnectionBadge: element<HTMLElement>('#emiss-connection-badge'),
  emissConnectionDescription: element<HTMLElement>('#emiss-connection-description'),
  emissCatalogStatus: element<HTMLElement>('#emiss-catalog-status'),
  emissCatalogQuery: element<HTMLInputElement>('#emiss-catalog-query'),
  emissCatalogSearch: element<HTMLButtonElement>('#emiss-catalog-search-button'),
  emissCatalogRefresh: element<HTMLButtonElement>('#emiss-catalog-refresh'),
  emissCatalogIncludeExcluded: element<HTMLInputElement>('#emiss-catalog-include-excluded'),
  emissCatalogResults: element<HTMLElement>('#emiss-catalog-results'),
  emissIndicatorId: element<HTMLInputElement>('#emiss-indicator-id'),
  emissLocalId: element<HTMLInputElement>('#emiss-local-id'),
  emissName: element<HTMLInputElement>('#emiss-name'),
  emissUnit: element<HTMLInputElement>('#emiss-unit'),
  emissForceRefresh: element<HTMLInputElement>('#emiss-force-refresh'),
  emissActive: element<HTMLInputElement>('#emiss-active'),
  emissOverwrite: element<HTMLInputElement>('#emiss-overwrite'),
  emissDiagnostics: element<HTMLButtonElement>('#emiss-diagnostics'),
  emissInspect: element<HTMLButtonElement>('#emiss-inspect'),
  emissRegister: element<HTMLButtonElement>('#emiss-register'),
  emissManagerMessage: element<HTMLElement>('#emiss-manager-message'),
  emissInspectionSummary: element<HTMLElement>('#emiss-inspection-summary'),
  emissFilterList: element<HTMLElement>('#emiss-filter-list'),
  emissRequestLog: element<HTMLElement>('#emiss-request-log'),
  refreshEmissLog: element<HTMLButtonElement>('#refresh-emiss-log'),
  settingsFab: element<HTMLButtonElement>('#settings-fab'),
  localeToggle: element<HTMLButtonElement>('#locale-toggle'),
  localeToggleCode: element<HTMLElement>('#locale-toggle-code'),
  settingsPopover: element<HTMLElement>('#settings-popover'),
  settingsLocaleRu: element<HTMLButtonElement>('#settings-locale-ru'),
  settingsLocaleEn: element<HTMLButtonElement>('#settings-locale-en'),
  settingsThemeSystem: element<HTMLButtonElement>('#settings-theme-system'),
  settingsThemeLight: element<HTMLButtonElement>('#settings-theme-light'),
  settingsThemeDark: element<HTMLButtonElement>('#settings-theme-dark'),
  settingsPrimaryColor: element<HTMLInputElement>('#settings-primary-color'),
  settingsPresets: element<HTMLElement>('#settings-presets'),
  settingsResetColors: element<HTMLButtonElement>('#settings-reset-colors'),
  settingsColorWarning: element<HTMLElement>('#settings-color-warning'),
  autoBuilderButton: element<HTMLButtonElement>('#auto-builder-button'),
  autoBuilderDialog: element<HTMLDialogElement>('#auto-builder-dialog'),
  autoBuilderClose: element<HTMLButtonElement>('#auto-builder-close'),
  autoBuilderCancel: element<HTMLButtonElement>('#auto-builder-cancel'),
  autoBuilderCreate: element<HTMLButtonElement>('#auto-builder-create'),
  autoBuilderStatus: element<HTMLElement>('#auto-builder-status'),
  autoSource: element<HTMLSelectElement>('#auto-source-select'),
  autoSectionSearch: element<HTMLInputElement>('#auto-section-search'),
  autoSection: element<HTMLSelectElement>('#auto-section-select'),
  autoPickEnabled: element<HTMLInputElement>('#auto-pick-enabled'),
  autoFillMissing: element<HTMLInputElement>('#auto-fill-missing'),
  autoIndicatorSearch: element<HTMLInputElement>('#auto-indicator-search'),
  autoIndicatorChoiceList: element<HTMLElement>('#auto-indicator-choice-list'),
  autoIndicatorCounter: element<HTMLElement>('#auto-indicator-counter'),
  autoBdmoTerritoryPanel: element<HTMLElement>('#auto-bdmo-territory-panel'),
  autoGenericTerritoryPanel: element<HTMLElement>('#auto-generic-territory-panel'),
  autoDistrictSearch: element<HTMLInputElement>('#auto-district-search'),
  autoDistricts: element<HTMLSelectElement>('#auto-district-select'),
  autoDistrictChoiceList: element<HTMLElement>('#auto-district-choice-list'),
  autoDistrictCounter: element<HTMLElement>('#auto-district-counter'),
  autoDistrictSelectAll: element<HTMLButtonElement>('#auto-district-select-all'),
  autoDistrictClear: element<HTMLButtonElement>('#auto-district-clear'),
  autoRegionSearch: element<HTMLInputElement>('#auto-region-search'),
  autoRegions: element<HTMLSelectElement>('#auto-region-select'),
  autoRegionChoiceList: element<HTMLElement>('#auto-region-choice-list'),
  autoRegionCounter: element<HTMLElement>('#auto-region-counter'),
  autoRegionSelectAll: element<HTMLButtonElement>('#auto-region-select-all'),
  autoRegionClear: element<HTMLButtonElement>('#auto-region-clear'),
  autoMunicipalitySearch: element<HTMLInputElement>('#auto-municipality-search'),
  autoMunicipalities: element<HTMLSelectElement>('#auto-municipality-select'),
  autoMunicipalityChoiceList: element<HTMLElement>('#auto-municipality-choice-list'),
  autoMunicipalityCounter: element<HTMLElement>('#auto-municipality-counter'),
  autoMunicipalitySelectAll: element<HTMLButtonElement>('#auto-municipality-select-all'),
  autoMunicipalityClear: element<HTMLButtonElement>('#auto-municipality-clear'),
  autoTerritorySearch: element<HTMLInputElement>('#auto-territory-search'),
  autoTerritories: element<HTMLSelectElement>('#auto-territory-select'),
  autoTerritoryChoiceList: element<HTMLElement>('#auto-territory-choice-list'),
  autoTerritoryCounter: element<HTMLElement>('#auto-territory-counter'),
  autoTerritorySelectAll: element<HTMLButtonElement>('#auto-territory-select-all'),
  autoTerritoryClear: element<HTMLButtonElement>('#auto-territory-clear'),
  autoYearSearch: element<HTMLInputElement>('#auto-year-search'),
  autoYears: element<HTMLSelectElement>('#auto-year-select'),
  autoYearChoiceList: element<HTMLElement>('#auto-year-choice-list'),
  autoYearCounter: element<HTMLElement>('#auto-year-counter'),
  autoYearSelectAll: element<HTMLButtonElement>('#auto-year-select-all'),
  autoYearClear: element<HTMLButtonElement>('#auto-year-clear'),
  autoYearHelp: element<HTMLElement>('#auto-year-help'),
  autoPrimaryColor: element<HTMLInputElement>('#auto-primary-color'),
  autoColorPresets: element<HTMLElement>('#auto-color-presets'),
  autoColorReset: element<HTMLButtonElement>('#auto-color-reset'),
};
